import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.scss';
import Cinderace from './pages/Cinderace';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Cinderace />
  </React.StrictMode>
);
